import { AccountsProps } from '../types';

function Accounts({ children }: AccountsProps) {
    return (
        <div className="user-settings">
            {children}
        </div>
    );
}

export default Accounts;
